export default "/kiban/_next/static/images/01_rigid-6f59ec8222450ed96cf0314dbd4d9acf.png";